import { Card, Box, styled } from "@mui/material";
import { colors } from '../../theme/colors';

export const CardWrapper = styled(Card)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "32px 28px",
  border: "1px solid rgba(145, 158, 171, 0.24)",
  borderRadius: "16px",
  width: "100%",
  maxWidth: "400px",
  boxSizing: "border-box",
  maxHeight: "90vh",
  overflowY: "auto",
  boxShadow: "0 10px 30px rgba(127, 29, 29, 0.08)",
});

export const MainContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
  width: "100vw",
  background: "linear-gradient(135deg, #fef6f6 0%, #f8f9fb 100%)",
  padding: "20px",
  boxSizing: "border-box",
  "& .logo":{
    height: "36px",
    width: "auto",
    objectFit: "contain",
  },
  "& .heading":{
    marginTop:"20px",
    color:colors.primary,
    fontWeight:600,
    fontSize:"medium"
  },
  "& .link":{
    color:colors.link,
    fontSize:"small",
    fontWeight:500,
    display:"flex",
    justifyContent:"center",
  },
  "& .back-button":{
    textAlign: "center", 
    fontSize: "small", 
    fontWeight: 500, 
    color: colors.primary,
  }
});
